@use '@design/design-tokens/breakpoints/breakpoints' as *;
@use '@design/components/custom-scroll/custom-scroll' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;

.sourcesList {
  max-height: 30vh;
  overflow: hidden auto;
  @include custom-scroll-minimal;
  border-bottom-left-radius: border-radius(r2);
  display: flex;
  flex-direction: column;

  @include respond-to('max-sm') {
    max-height: 20vh;
  }
}
